import React from "react";

function Aboutus() {
  return <div>This is about us page</div>;
}

export default Aboutus;
